import React from "react";
import BrainBankManagement from "./KnowledgeBaseComponents/BrainBankManagement";

const KnowledgeBase = () => {
  return <BrainBankManagement />;
};

export default KnowledgeBase;